import { pageSelectorGenerator } from '@test/pageSelectors';

export const CancelGiftWarningSelectors = pageSelectorGenerator('CancelGiftWarning', ['ContainerElement', 'AffirmativeButton', 'NegativeButton']);
